export const QueryKeys = {
    AssignmentBudgetChartsData: "assignmentBudgetChartsData",
    AssignmentsList: "assignmentsList",
    AssignmentsPhaseList: "assignmentsPhaseList",
    AssignmentsPhase: "assignmentsPhase",
    AssignmentWorkLocationsList: "assignmentWorkLocationsList",
    AssignmentRosterList: "assignmentRosterList",
    AssignmentRosterDetailList: "assignmentRosterDetailList",
    AssignmentRosterDetail: "assignmentRosterDetail",
    AssignmentExpense: "assignmentExpense",
    AssignmentExpenseList: "assignmentExpenseList",
    AssignmentDetail: "assignmentDetail",
    AssignmentDetailSearch: "assignmentDetailSearch",
    AssignmentDetailGrid: "assignmentDetailGrid",
    AssignmentInvoiceType: "assignmentInvoiceType",
    AssignmentWpCodeRequired: "assignmentWpCodeRequired",
    GetBudget: "getBudget",
    BudgetSearch: "budgetSearch",
    BudgetTotals: "budgetTotals",
    GetClient: "getClient",
    ClientGrid: "clientGrid",
    ClientList: "clientList",
    ExpenseCostRate: "expenseCostRate",
    ExtensionsList: "extensionsList",
    CompleteAssignment: "completeAssignment",
    InvoiceAssignmentsList: "invoiceAssignmentsList",
    Invoice: "invoice",
    InvoiceManagementSearch: "invoiceManagementSearch",
    InvoiceManagementIncludedEntries: "invoiceManagementIncludedEntries",
    InvoiceManagementIncludedEntriesTotals: "invoiceManagementIncludedEntriesTotals",
    InvoiceManagementPotentialEntries: "invoiceManagementPotentialEntries",
    InvoiceManagementPotentialEntriesTotals: "invoiceManagementPotentialEntriesTotals",
    InvoiceManagementAdjustments: "invoiceManagementAdjustmentsEntries",
    InvoiceManagementAdjustmentsTotals: "invoiceManagementAdjustmentsTotals",
    MembershipRolesList: "membershipRolesList",
    UtilizationCodesList: "utilizationCodesList",
    BillingTermsList: "billingTermsList",
    InvoiceTypesList: "invoiceTypesList",
    InvoiceStylesList: "invoiceStylesList",
    ProjectRolesList: "projectRolesList",
    StateCodeList: "stateCodeList",
    Staff: "staff",
    StaffGrid: "staffGrid",
    StaffingList: "staffingList",
    CompanyList: "companyList",
    StaffProfileList: "staffProfileList",
    StaffRatesList: "staffRatesList",
    StaffPerformanceList: "staffPerformanceList",
    StaffAssignmentsList: "staffAssignmentsList",
    GetSortedStaffCompany: "getSortedStaffCompany",
    GetStaffCompany: "getStaffCompany",
    GetSortedFullTimeEmployee: "getSortedFullTimeEmployee",
    GetSortedBillingTerm: "getSortedBillingTerm",
    GetBillingTerm: "getBillingTerm",
    GetSortedExtension: "getSortedExtension",
    GetSortedSubCategoryDefaultRate: "getSortedSubCategoryDefaultRate",
    GetSortedSubCategoryAccountingDetail: "getSortedSubCategoryAccountingDetail",
    GetSubCategoryDefaultRate: "getSubCategoryDefaultRate",
    GetSubCategoryAccountingDetail: "getSubCategoryAccountingDetail",
    GetExtension: "getExtension",
    GetSortedInvoiceStyle: "getSortedInvoiceStyle",
    GetInvoiceStyle: "getInvoiceStyle",
    GetSortedInvoiceType: "getSortedInvoiceType",
    GetInvoiceType: "getInvoiceType",
    GetSortedProjectRole: "getSortedProjectRole",
    GetProjectRole: "getProjectRole",
    GetSortedUtilizationCode: "getSortedUtilizationCode",
    GetUtilizationCode: "getUtilizationCode",
    GetSortedEntryCategory: "getSortedEntryCategory",
    GetSortedAccountingCategory: "getSortedAccountingCategory",
    GetAccountingCategory: "getAccountingCategory",
    GetSortedAccountingCode: "getSortedAccountingCode",
    GetAccountingCode: "getAccountingCode",
    GetSortedReimbursableExpenseExceptions: "getSortedReimbursableExpenseExceptions",
    GetReimbursableExpenseException: "getReimbursableExpenseException",
    GetSortedStateCode: "getSortedStateCode",
    GetStateCode: "getStateCode",
    GetSortedClientCategory: "getSortedClientCategory",
    GetSortedCityState: "getSortedCityState",
    GetCityState: "getCityState",
    GetSystemInfo: "getSystemInfo",
    GetCategories: "getCategories",
    GetSubcategoryList: "getSubcategoryList",
    GetSortedSubCategories: "getSortedSubCategories",
    GetSubCategory: "getSubCategory",
    GetSubCategoryGroupsByCategoryId: "getSubCategoryGroupsByCategoryId",
    GetSubCategoriesBySubCategoryId: "getSubCategoriesBySubCategoryId",
    GetSubCategoryGroupsBySubCategoryId: "getSubCategoryGroupsBySubCategoryId",
    GetSortedSubCategoryGroups: "getSortedSubCategoryGroups",
    GetSubCategoryGroup: "getSubCategoryGroup",
    GetClientCategory: "getClientCategory",
    GetClientCategories: "getClientCategories",
    GetEntryCategory: "getEntryCategory",
    GetEntriesSearchList: "getEntriesSearchList",
    GetEntryTotals: "getEntryTotals",
    GetEntryTotalsAcrossCategories: "getEntryTotalsAcrossCategories",
    GetEntry: "getEntry",
    NextEntry: "nextEntry",
    PowerBiReports: "powerBiReports",
    PowerBiSettings: "powerBiSettings",
    PreviousEntry: "previousEntry",
    RosterProjectRole: "rosterProjectRole",
    GetEntryReceipt: "getEntryReceipt",
    GetNeedingReceipt: "getNeedingReceipt",
    WorkLocation: "workLocation",
    WorkLocationList: "workLocationList",
    WorkPackageListByAssignment: "workPackageListByAssignment",
    WorkPackage: "workPackage",
    FilterWorkPackagesList: "filterWorkPackagesList",
} as const;
